<template>
  <div class="p-the-c01-form-extra-prop">
    <label :for="id" class="p-the-c01-form-extra-prop__label">{{
      label
    }}</label>
    <InputText
      :id="id"
      :name="id"
      type="text"
      v-model="internalValue"
      :placeholder="placeholder"
    />
  </div>
</template>

<script lang="ts">
import InputText from "@/common/components/atoms/InputText.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    id: { type: String, required: true, default: "" },
    label: { type: String, required: true, default: "" },
    value: { type: String, required: true, default: "" },
    placeholder: { type: String, required: true, default: "" }
  },
  components: {
    InputText
  }
})
export default class C01ItemFormExtraProp extends Vue {
  id!: string;
  label!: string;
  value!: string;
  placeholder!: string;

  get internalValue() {
    return this.value;
  }
  set internalValue(newValue) {
    if (this.value !== newValue) {
      this.$emit("input", newValue);
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-c01-form-extra-prop {
  &__label {
    @include text__body--s;
    font-weight: bold;
    line-height: rem(19);
    color: $common-black-sub;
  }
}
</style>
